import { render, staticRenderFns } from "./BpaI.vue?vue&type=template&id=0c18e458"
import script from "./BpaI.vue?vue&type=script&lang=js"
export * from "./BpaI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports